// // import React from 'react';
// // import Navbar from '../../Components/Navbar';
// // import Footer from '../../Components/Footer/Footer';
// // import './About.css';

// // const About = () => {

// //   return (
// //     <div className="aboutpage-container">
// //       <Navbar />

// //       {/* Hero Section */}
// //       <section className="aboutpage-hero aboutpage-section">
// //         <div className="aboutpage-hero-content">
// //           <h1 className="aboutpage-hero-title aboutpage-animate-float">
// //             About <span>HelpNao</span>
// //           </h1>
// //           <p className="aboutpage-hero-text">
// //             Revolutionizing service connections with trust, security, and convenience at the heart of everything we do.
// //           </p>
// //         </div>
// //       </section>

// //       {/* Mission Section */}
// //       <section className="aboutpage-mission aboutpage-section">
// //         <div className="aboutpage-mission-content">
// //           <div className="aboutpage-mission-text">
// //             <h2 className="aboutpage-mission-heading">Our Mission</h2>
// //             <p className="aboutpage-mission-description">
// //               HelpNao bridges the gap between homeowners seeking reliable services and skilled professionals ready to help. We've created a secure, user-friendly platform that makes finding and providing home services effortless and trustworthy.
// //             </p>
// //             <p className="aboutpage-mission-description">
// //               Our mission is to build a community where quality service meets genuine need, ensuring every interaction is safe, professional, and mutually beneficial.
// //             </p>
// //             <div className="aboutpage-mission-stats">
// //               <div className="aboutpage-stat">
// //                 <div className="aboutpage-stat-number">10K+</div>
// //                 <div className="aboutpage-stat-label">Happy Users</div>
// //               </div>
// //               <div className="aboutpage-stat">
// //                 <div className="aboutpage-stat-number">5K+</div>
// //                 <div className="aboutpage-stat-label">Verified Servitors</div>
// //               </div>
// //               <div className="aboutpage-stat">
// //                 <div className="aboutpage-stat-number">50K+</div>
// //                 <div className="aboutpage-stat-label">Completed Services</div>
// //               </div>
// //             </div>
// //           </div>
// //           <div className="aboutpage-mission-image">
// //             <div className="aboutpage-mission-graphic">
// //               <span role="img" aria-label="handshake" className="aboutpage-graphic-emoji">🤝</span>
// //               <h3 className="aboutpage-mission-graphic-title">Connecting Communities</h3>
// //               <p className="aboutpage-mission-graphic-text">
// //                 Building bridges between those who need help and those who can provide it, creating a safer and more connected world.
// //               </p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Services Section */}
// //       <section className="aboutpage-services aboutpage-section">
// //         <div className="aboutpage-services-content">
// //           <h2 className="aboutpage-services-heading">What We Offer</h2>
// //           <p className="aboutpage-services-subtitle">
// //             Professional home services at your fingertips, delivered by verified experts in their fields.
// //           </p>
// //           <div className="aboutpage-services-cards">
// //             <div className="aboutpage-service-card aboutpage-card-shadow">
// //               {/* <span role="img" aria-label="lightning" className="aboutpage-service-icon">⚡</span> */}
// //               <h3 className="aboutpage-service-title">Electrical Services</h3>
// //               <p className="aboutpage-service-description">
// //                 Professional electricians for installations, repairs, and maintenance. From simple fixes to complex wiring projects.
// //               </p>
// //               <ul className="aboutpage-service-list">
// //                 <li>• Wiring & Rewiring</li>
// //                 <li>• Light Installation</li>
// //                 <li>• Circuit Repairs</li>
// //                 <li>• Safety Inspections</li>
// //               </ul>
// //             </div>
// //             <div className="aboutpage-service-card aboutpage-card-shadow">
// //               {/* <span role="img" aria-label="broom" className="aboutpage-service-icon">🧽</span> */}
// //               <h3 className="aboutpage-service-title">Home Cleaning</h3>
// //               <p className="aboutpage-service-description">
// //                 Thorough cleaning services to keep your home spotless and healthy. Regular or one-time cleaning options available.
// //               </p>
// //               <ul className="aboutpage-service-list">
// //                 <li>• Deep Cleaning</li>
// //                 <li>• Regular Maintenance</li>
// //                 <li>• Move-in/Move-out</li>
// //                 <li>• Specialized Cleaning</li>
// //               </ul>
// //             </div>
// //             <div className="aboutpage-service-card aboutpage-card-shadow">
// //               {/* <span role="img" aria-label="wrench" className="aboutpage-service-icon">🔧</span> */}
// //               <h3 className="aboutpage-service-title">Plumbing Services</h3>
// //               <p className="aboutpage-service-description">
// //                 Expert plumbers for all your water and drainage needs. Emergency services and routine maintenance available.
// //               </p>
// //               <ul className="aboutpage-service-list">
// //                 <li>• Pipe Repairs</li>
// //                 <li>• Drain Cleaning</li>
// //                 <li>• Fixture Installation</li>
// //                 <li>• Emergency Services</li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* How It Works Section */}
// //       <section className="aboutpage-how-it-works aboutpage-section">
// //         <div className="aboutpage-how-it-works-content">
// //           <h2 className="aboutpage-how-it-works-heading">How HelpNao Works</h2>
// //           <p className="aboutpage-how-it-works-subtitle">
// //             Our streamlined process ensures security, quality, and peace of mind for every service request.
// //           </p>
// //           <div className="aboutpage-how-it-works-columns">
// //             <div className="aboutpage-how-it-works-column">
// //               <h3 className="aboutpage-how-it-works-column-title">For Users</h3>
// //               <div className="aboutpage-how-it-works-steps">
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-user">1</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Request Service</h4>
// //                     <p>Choose your needed service and provide details about your requirements.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-user">2</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Get Matched</h4>
// //                     <p>Our system connects you with verified professionals in your area.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-user">3</div>
// //                   <div className="aboutpage-step-text">
// //                     {/* <h4>Secure PIN Verification</h4> */}
// //                     <h4>Secure Verification Code</h4>
// //                     <p>Receive a unique 6-Character Verification Code to verify the service provider when they arrive.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-user">4</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Service Completion</h4>
// //                     <p>Confirm completion and rate your experience to help our community grow.</p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="aboutpage-how-it-works-column">
// //               <h3 className="aboutpage-how-it-works-column-title">For Service Providers</h3>
// //               <div className="aboutpage-how-it-works-steps">
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-servitor">1</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Apply & Get Verified</h4>
// //                     <p>Submit your credentials and undergo our thorough verification process.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-servitor">2</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Receive Orders</h4>
// //                     <p>Get notified of service requests that match your expertise and availability.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-servitor">3</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Provide Service</h4>
// //                     <p>Use the PIN system for secure verification and complete the service professionally.</p>
// //                   </div>
// //                 </div>
// //                 <div className="aboutpage-step">
// //                   <div className="aboutpage-step-number aboutpage-step-servitor">4</div>
// //                   <div className="aboutpage-step-text">
// //                     <h4>Earn & Grow</h4>
// //                     <p>Get paid securely and build your reputation through customer ratings.</p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Security Features Section */}
// //       <section className="aboutpage-security aboutpage-section">
// //         <div className="aboutpage-security-content">
// //           <h2 className="aboutpage-security-heading">Built for Security & Trust</h2>
// //           <p className="aboutpage-security-subtitle">
// //             Advanced security measures and verification systems ensure every interaction is safe and reliable.
// //           </p>
// //           <div className="aboutpage-security-features">
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
// //                 </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">Admin Verification</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 All service providers undergo thorough background checks and credential verification before approval.
// //               </p>
// //             </div>
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
// //                 </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">PIN Security System</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 Unique 6-character PINs for each service ensure only authorized providers can complete your orders.
// //               </p>
// //             </div>
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
// //                 </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">Real-time Tracking</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 Monitor service progress in real-time with status updates and availability management.
// //               </p>
// //             </div>
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   {/* ⭐ */}
// //                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
// //                 </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">Rating & Review System</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 Mutual rating system helps maintain quality and builds trust within our community.
// //               </p>
// //             </div>
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
// //                 </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">Account Management</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 Comprehensive user and provider account management with blocking and approval systems.
// //               </p>
// //             </div>
// //             <div className="aboutpage-security-feature">
// //               <div className="aboutpage-security-icon-wrapper">
// //                 <div className="aboutpage-security-icon">
// //                   {/* <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60f549" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                   <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
// //                 </svg> */}
// //                 <svg
// //                     width="32"
// //                     height="32"
// //                     viewBox="0 0 24 24"
// //                     fill="none"
// //                     stroke="#60f549"
// //                     strokeWidth="2"
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                   >
// //                     <path d="M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5" />
// //                     <path d="M8 11h6" />
// //                     <circle cx="16.5" cy="15.5" r="1" />
// //                   </svg>
// //                 </div>
// //               </div>
// //               <h3 className="aboutpage-security-feature-title">Secure Payments</h3>
// //               <p className="aboutpage-security-feature-text">
// //                 Protected payment processing ensures safe and timely transactions for all parties.
// //               </p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Values Section */}
// //       <section className="aboutpage-values aboutpage-section">
// //         <div className="aboutpage-values-content">
// //           <h2 className="aboutpage-values-heading">Our Values</h2>
// //           <p className="aboutpage-values-subtitle">
// //             The principles that guide everything we do at HelpNao.
// //           </p>
// //           <div className="aboutpage-values-grid">
// //             <div className="aboutpage-value">
// //               <div className="aboutpage-value-icon">🔒</div>
// //               <h3 className="aboutpage-value-title">Security First</h3>
// //               <p className="aboutpage-value-text">Every feature is built with security and trust as the foundation.</p>
// //             </div>
// //             <div className="aboutpage-value">
// //               <div className="aboutpage-value-icon">⚡</div>
// //               <h3 className="aboutpage-value-title">Efficiency</h3>
// //               <p className="aboutpage-value-text">Streamlined processes that save time for both users and providers.</p>
// //             </div>
// //             <div className="aboutpage-value">
// //               <div className="aboutpage-value-icon">🤝</div>
// //               <h3 className="aboutpage-value-title">Community</h3>
// //               <p className="aboutpage-value-text">Building stronger communities through mutual support and collaboration.</p>
// //             </div>
// //             <div className="aboutpage-value">
// //               <div className="aboutpage-value-icon">✨</div>
// //               <h3 className="aboutpage-value-title">Quality</h3>
// //               <p className="aboutpage-value-text">Maintaining high standards through verification and feedback systems.</p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA Section */}
// //       <section className="aboutpage-cta aboutpage-section">
// //         <div className="aboutpage-cta-content">
// //           <h2 className="aboutpage-cta-heading">
// //             Ready to Experience Hassle-Free Services?
// //           </h2>
// //           <p className="aboutpage-cta-text">
// //             Join thousands of satisfied users and verified professionals in our growing community.
// //           </p>
// //           <div className="aboutpage-cta-buttons">
// //             <button className="aboutpage-cta-button primary">Find Services</button>
// //             <button className="aboutpage-cta-button secondary">Become a Provider</button>
// //           </div>
// //         </div>
// //       </section>

// //       <Footer />
// //     </div>
// //   );
// // };

// // export default About;

// import React, { useEffect, useState } from 'react';
// import Navbar from '../../Components/Navbar';
// import Footer from '../../Components/Footer/Footer';
// import './About.css';

// const About = () => {
//   const [stats, setStats] = useState({
//     users: 0,
//     servitors: 0,
//     services: 0,
//   });

//   useEffect(() => {
//     const targetStats = { users: 10000, servitors: 5000, services: 50000 };
//     const duration = 2000; // Animation duration in milliseconds
//     const stepTime = 20; // Time per step in milliseconds
//     const steps = Math.ceil(duration / stepTime);

//     const animateCount = (start, end, element) => {
//       let current = start;
//       const increment = (end - start) / steps;
//       const timer = setInterval(() => {
//         current += increment;
//         if (current >= end) {
//           clearInterval(timer);
//           current = end;
//         }
//         element(current);
//       }, stepTime);
//     };

//     animateCount(0, targetStats.users, (val) => setStats((prev) => ({ ...prev, users: Math.floor(val) })));
//     animateCount(0, targetStats.servitors, (val) => setStats((prev) => ({ ...prev, servitors: Math.floor(val) })));
//     animateCount(0, targetStats.services, (val) => setStats((prev) => ({ ...prev, services: Math.floor(val) })));
//   }, []);

//   return (
//     <div className="aboutpage-container">
//       <Navbar />

//       {/* Hero Section */}
//       <section className="aboutpage-hero aboutpage-section">
//         <div className="aboutpage-hero-content">
//           <h1 className="aboutpage-hero-title aboutpage-animate-float">
//             About <span>HelpNao</span>
//           </h1>
//           <p className="aboutpage-hero-text">
//             Revolutionizing service connections with trust, security, and convenience at the heart of everything we do.
//           </p>
//         </div>
//       </section>

//       {/* Mission Section */}
//       <section className="aboutpage-mission aboutpage-section">
//         <div className="aboutpage-mission-content">
//           <div className="aboutpage-mission-text">
//             <h2 className="aboutpage-mission-heading">Our Mission</h2>
//             <p className="aboutpage-mission-description">
//               HelpNao bridges the gap between homeowners seeking reliable services and skilled professionals ready to help. We've created a secure, user-friendly platform that makes finding and providing home services effortless and trustworthy.
//             </p>
//             <p className="aboutpage-mission-description">
//               Our mission is to build a community where quality service meets genuine need, ensuring every interaction is safe, professional, and mutually beneficial.
//             </p>
//             <div className="aboutpage-mission-stats">
//               <div className="aboutpage-stat">
//                 <div className="aboutpage-stat-number">{stats.users}+</div>
//                 <div className="aboutpage-stat-label">Happy Users</div>
//               </div>
//               <div className="aboutpage-stat">
//                 <div className="aboutpage-stat-number">{stats.servitors}+</div>
//                 <div className="aboutpage-stat-label">Verified Servitors</div>
//               </div>
//               <div className="aboutpage-stat">
//                 <div className="aboutpage-stat-number">{stats.services}+</div>
//                 <div className="aboutpage-stat-label">Completed Services</div>
//               </div>
//             </div>
//           </div>
//           <div className="aboutpage-mission-image">
//             <div className="aboutpage-mission-graphic">
//               <span role="img" aria-label="handshake" className="aboutpage-graphic-emoji">🤝</span>
//               <h3 className="aboutpage-mission-graphic-title">Connecting Communities</h3>
//               <p className="aboutpage-mission-graphic-text">
//                 Building bridges between those who need help and those who can provide it, creating a safer and more connected world.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="aboutpage-services aboutpage-section">
//         <div className="aboutpage-services-content">
//           <h2 className="aboutpage-services-heading">What We Offer</h2>
//           <p className="aboutpage-services-subtitle">
//             Professional home services at your fingertips, delivered by verified experts in their fields.
//           </p>
//           <div className="aboutpage-services-cards">
//             <div className="aboutpage-service-card aboutpage-card-shadow">
//               <h3 className="aboutpage-service-title">Electrical Services</h3>
//               <p className="aboutpage-service-description">
//                 Professional electricians for installations, repairs, and maintenance. From simple fixes to complex wiring projects.
//               </p>
//               <ul className="aboutpage-service-list">
//                 <li>• Wiring & Rewiring</li>
//                 <li>• Light Installation</li>
//                 <li>• Circuit Repairs</li>
//                 <li>• Safety Inspections</li>
//               </ul>
//             </div>
//             <div className="aboutpage-service-card aboutpage-card-shadow">
//               <h3 className="aboutpage-service-title">Home Cleaning</h3>
//               <p className="aboutpage-service-description">
//                 Thorough cleaning services to keep your home spotless and healthy. Regular or one-time cleaning options available.
//               </p>
//               <ul className="aboutpage-service-list">
//                 <li>• Deep Cleaning</li>
//                 <li>• Regular Maintenance</li>
//                 <li>• Move-in/Move-out</li>
//                 <li>• Specialized Cleaning</li>
//               </ul>
//             </div>
//             <div className="aboutpage-service-card aboutpage-card-shadow">
//               <h3 className="aboutpage-service-title">Plumbing Services</h3>
//               <p className="aboutpage-service-description">
//                 Expert plumbers for all your water and drainage needs. Emergency services and routine maintenance available.
//               </p>
//               <ul className="aboutpage-service-list">
//                 <li>• Pipe Repairs</li>
//                 <li>• Drain Cleaning</li>
//                 <li>• Fixture Installation</li>
//                 <li>• Emergency Services</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* How It Works Section */}
//       <section className="aboutpage-how-it-works aboutpage-section">
//         <div className="aboutpage-how-it-works-content">
//           <h2 className="aboutpage-how-it-works-heading">How HelpNao Works</h2>
//           <p className="aboutpage-how-it-works-subtitle">
//             Our streamlined process ensures security, quality, and peace of mind for every service request.
//           </p>
//           <div className="aboutpage-how-it-works-columns">
//             <div className="aboutpage-how-it-works-column">
//               <h3 className="aboutpage-how-it-works-column-title">For Users</h3>
//               <div className="aboutpage-how-it-works-steps">
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-user">1</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Request Service</h4>
//                     <p>Choose your needed service and provide details about your requirements.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-user">2</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Get Matched</h4>
//                     <p>Our system connects you with verified professionals in your area.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-user">3</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Secure Verification Code</h4>
//                     <p>Receive a unique 6-Character Verification Code to verify the service provider when they arrive.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-user">4</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Service Completion</h4>
//                     <p>Confirm completion and rate your experience to help our community grow.</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="aboutpage-how-it-works-column">
//               <h3 className="aboutpage-how-it-works-column-title">For Service Providers</h3>
//               <div className="aboutpage-how-it-works-steps">
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-servitor">1</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Apply & Get Verified</h4>
//                     <p>Submit your credentials and undergo our thorough verification process.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-servitor">2</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Receive Orders</h4>
//                     <p>Get notified of service requests that match your expertise and availability.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-servitor">3</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Provide Service</h4>
//                     <p>Use the PIN system for secure verification and complete the service professionally.</p>
//                   </div>
//                 </div>
//                 <div className="aboutpage-step">
//                   <div className="aboutpage-step-number aboutpage-step-servitor">4</div>
//                   <div className="aboutpage-step-text">
//                     <h4>Earn & Grow</h4>
//                     <p>Get paid securely and build your reputation through customer ratings.</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Security Features Section */}
//       <section className="aboutpage-security aboutpage-section">
//         <div className="aboutpage-security-content">
//           <h2 className="aboutpage-security-heading">Built for Security & Trust</h2>
//           <p className="aboutpage-security-subtitle">
//             Advanced security measures and verification systems ensure every interaction is safe and reliable.
//           </p>
//           <div className="aboutpage-security-features">
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">Admin Verification</h3>
//               <p className="aboutpage-security-feature-text">
//                 All service providers undergo thorough background checks and credential verification before approval.
//               </p>
//             </div>
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">PIN Security System</h3>
//               <p className="aboutpage-security-feature-text">
//                 Unique 6-character PINs for each service ensure only authorized providers can complete your orders.
//               </p>
//             </div>
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">Real-time Tracking</h3>
//               <p className="aboutpage-security-feature-text">
//                 Monitor service progress in real-time with status updates and availability management.
//               </p>
//             </div>
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">Rating & Review System</h3>
//               <p className="aboutpage-security-feature-text">
//                 Mutual rating system helps maintain quality and builds trust within our community.
//               </p>
//             </div>
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">Account Management</h3>
//               <p className="aboutpage-security-feature-text">
//                 Comprehensive user and provider account management with blocking and approval systems.
//               </p>
//             </div>
//             <div className="aboutpage-security-feature">
//               <div className="aboutpage-security-icon-wrapper">
//                 <div className="aboutpage-security-icon">
//                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5" />
//                     <path d="M8 11h6" />
//                     <circle cx="16.5" cy="15.5" r="1" />
//                   </svg>
//                 </div>
//               </div>
//               <h3 className="aboutpage-security-feature-title">Secure Payments</h3>
//               <p className="aboutpage-security-feature-text">
//                 Protected payment processing ensures safe and timely transactions for all parties.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Values Section */}
//       <section className="aboutpage-values aboutpage-section">
//         <div className="aboutpage-values-content">
//           <h2 className="aboutpage-values-heading">Our Values</h2>
//           <p className="aboutpage-values-subtitle">
//             The principles that guide everything we do at HelpNao.
//           </p>
//           <div className="aboutpage-values-grid">
//             <div className="aboutpage-value">
//               <div className="aboutpage-value-icon">🔒</div>
//               <h3 className="aboutpage-value-title">Security First</h3>
//               <p className="aboutpage-value-text">Every feature is built with security and trust as the foundation.</p>
//             </div>
//             <div className="aboutpage-value">
//               <div className="aboutpage-value-icon">⚡</div>
//               <h3 className="aboutpage-value-title">Efficiency</h3>
//               <p className="aboutpage-value-text">Streamlined processes that save time for both users and providers.</p>
//             </div>
//             <div className="aboutpage-value">
//               <div className="aboutpage-value-icon">🤝</div>
//               <h3 className="aboutpage-value-title">Community</h3>
//               <p className="aboutpage-value-text">Building stronger communities through mutual support and collaboration.</p>
//             </div>
//             <div className="aboutpage-value">
//               <div className="aboutpage-value-icon">✨</div>
//               <h3 className="aboutpage-value-title">Quality</h3>
//               <p className="aboutpage-value-text">Maintaining high standards through verification and feedback systems.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="aboutpage-cta aboutpage-section">
//         <div className="aboutpage-cta-content">
//           <h2 className="aboutpage-cta-heading">
//             Ready to Experience Hassle-Free Services?
//           </h2>
//           <p className="aboutpage-cta-text">
//             Join thousands of satisfied users and verified professionals in our growing community.
//           </p>
//           <div className="aboutpage-cta-buttons">
//             <button className="aboutpage-cta-button primary">Find Services</button>
//             <button className="aboutpage-cta-button secondary">Become a Provider</button>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default About;

// ****** upper code is all okay checked last (17-6-25) ******* //

// ****** New updated with add Treanslator EN-BN (17-6-25) ******* //

// import React, { useEffect, useState } from "react";

import React  from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import { FaBolt, FaWrench, FaFire, FaWind } from "react-icons/fa";
import "./About.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import missionImage from "../../Assets/Helpnao_OurMission.png";
import SEO from "../../Components/SEO/SEO";


const About = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // const [stats, setStats] = useState({
  //   users: 0,
  //   servitors: 0,
  //   services: 0,
  // });

  // useEffect(() => {
  //   const targetStats = { users: 10000, servitors: 5000, services: 50000 };
  //   const duration = 2000; // Animation duration in milliseconds
  //   const stepTime = 20; // Time per step in milliseconds
  //   const steps = Math.ceil(duration / stepTime);

  //   const animateCount = (start, end, element) => {
  //     let current = start;
  //     const increment = (end - start) / steps;
  //     const timer = setInterval(() => {
  //       current += increment;
  //       if (current >= end) {
  //         clearInterval(timer);
  //         current = end;
  //       }
  //       element(current);
  //     }, stepTime);
  //   };

  //   animateCount(0, targetStats.users, (val) =>
  //     setStats((prev) => ({ ...prev, users: Math.floor(val) }))
  //   );
  //   animateCount(0, targetStats.servitors, (val) =>
  //     setStats((prev) => ({ ...prev, servitors: Math.floor(val) }))
  //   );
  //   animateCount(0, targetStats.services, (val) =>
  //     setStats((prev) => ({ ...prev, services: Math.floor(val) }))
  //   );
  // }, []);

  return (
    <div className="aboutpage-container">

      <SEO
        title={
          i18n.language === "bn"
            ? "HelpNao সম্পর্কে | বিশ্বস্ত হোম সার্ভিস প্ল্যাটফর্ম"
            : "About HelpNao | Trusted Home Service Platform"
        }
        description={
          i18n.language === "bn"
            ? "HelpNao আপনার দৈনন্দিন জীবনের কাজ সহজ করে। যাচাইকৃত ও দক্ষ সার্ভিস প্রোভাইডারের মাধ্যমে ইলেকট্রিশিয়ান, প্লাম্বার, এসি সার্ভিস, গ্যাস চুলা সার্ভিস বুক করুন।"
            : "HelpNao makes life easier with verified service providers. Book electrician, plumber, AC service, gas chula repair and more with confidence."
        }
        path="/about"
        lang={i18n.language === "bn" ? "bn" : "en"}
      />


      <Navbar />

      {/* Hero Section */}
      <section className="aboutpage-hero aboutpage-section">
        <div className="aboutpage-hero-content">
          <h1
            className="aboutpage-hero-title aboutpage-animate-float"
            dangerouslySetInnerHTML={{ __html: t("about.hero.title") }} // Line 46: Translated with HTML
          />
          <p className="aboutpage-hero-text">{t("about.hero.text")}</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="aboutpage-mission aboutpage-section">
        <div className="aboutpage-mission-content">
          <div className="aboutpage-mission-text">
            <h2 className="aboutpage-mission-heading">
              {t("about.mission.heading")}
            </h2>
            <p className="aboutpage-mission-description">
              {t("about.mission.description1")}
            </p>
            <p className="aboutpage-mission-description">
              {t("about.mission.description2")}
            </p>
            {/* <div className="aboutpage-mission-stats">
              <div className="aboutpage-stat">
                <div className="aboutpage-stat-number">{stats.users}+</div>
                <div className="aboutpage-stat-label">
                  {t("about.mission.stats.users")}
                </div>
              </div>
              <div className="aboutpage-stat">
                <div className="aboutpage-stat-number">{stats.servitors}+</div>
                <div className="aboutpage-stat-label">
                  {t("about.mission.stats.servitors")}
                </div>
              </div>
              <div className="aboutpage-stat">
                <div className="aboutpage-stat-number">{stats.services}+</div>
                <div className="aboutpage-stat-label">
                  {t("about.mission.stats.services")}
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="aboutpage-mission-image">
            <div className="aboutpage-mission-graphic">
              <span
                role="img"
                aria-label="handshake"
                className="aboutpage-graphic-emoji"
              >
                🤝
              </span>
              <h3 className="aboutpage-mission-graphic-title">
                {t("about.mission.graphic.title")}
              </h3>
              <p className="aboutpage-mission-graphic-text">
                {t("about.mission.graphic.text")}
              </p>
            </div>
          </div> */}

          <div className="aboutpage-mission-image">
            <img
              src={missionImage}
              alt={t("about.mission.graphic.title")}
              className="aboutpage-mission-img"
              loading="lazy"
            />
          </div>

        </div>
      </section>

      {/* Services Section */}
      {/* <section className="aboutpage-services aboutpage-section">
        <div className="aboutpage-services-content">
          <h2 className="aboutpage-services-heading">{t('about.services.heading')}</h2>
          <p className="aboutpage-services-subtitle">{t('about.services.subtitle')}</p>
          <div className="aboutpage-services-cards">
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <h3 className="aboutpage-service-title">{t('about.services.electrical.title')}</h3>
              <p className="aboutpage-service-description">{t('about.services.electrical.description')}</p>
              <ul className="aboutpage-service-list">
                <li>{t('about.services.electrical.list.wiring')}</li>
                <li>{t('about.services.electrical.list.light')}</li>
                <li>{t('about.services.electrical.list.circuit')}</li>
                <li>{t('about.services.electrical.list.safety')}</li>
              </ul>
            </div>
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <h3 className="aboutpage-service-title">{t('about.services.cleaning.title')}</h3>
              <p className="aboutpage-service-description">{t('about.services.cleaning.description')}</p>
              <ul className="aboutpage-service-list">
                <li>{t('about.services.cleaning.list.deep')}</li>
                <li>{t('about.services.cleaning.list.regular')}</li>
                <li>{t('about.services.cleaning.list.move')}</li>
                <li>{t('about.services.cleaning.list.specialized')}</li>
              </ul>
            </div>
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <h3 className="aboutpage-service-title">{t('about.services.plumbing.title')}</h3>
              <p className="aboutpage-service-description">{t('about.services.plumbing.description')}</p>
              <ul className="aboutpage-service-list">
                <li>{t('about.services.plumbing.list.pipe')}</li>
                <li>{t('about.services.plumbing.list.drain')}</li>
                <li>{t('about.services.plumbing.list.fixture')}</li>
                <li>{t('about.services.plumbing.list.emergency')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      <section className="aboutpage-services aboutpage-section">
        <div className="aboutpage-services-content">
          <h2 className="aboutpage-services-heading">
            {t("about.services.heading")}
          </h2>
          <p className="aboutpage-services-subtitle">
            {t("about.services.subtitle")}
          </p>

          <div className="aboutpage-services-cards">
            {/* Electrician */}
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <div className="aboutpage-service-card-inner">
                <div className="aboutpage-service-icon-wrapper">
                  <FaBolt
                    className="aboutpage-service-icon"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="aboutpage-service-title">
                  {t("about.services.electrician.title")}
                </h3>
                <p className="aboutpage-service-description">
                  {t("about.services.electrician.description")}
                </p>
                <div className="aboutpage-service-features">
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.electrician.list.safety_checks")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t(
                      "about.services.electrician.list.fan_light_installation"
                    )}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.electrician.list.wiring_rewiring")}
                  </span>
                </div>
              </div>
            </div>

            {/* Plumber */}
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <div className="aboutpage-service-card-inner">
                <div className="aboutpage-service-icon-wrapper">
                  <FaWrench
                    className="aboutpage-service-icon"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="aboutpage-service-title">
                  {t("about.services.plumber.title")}
                </h3>
                <p className="aboutpage-service-description">
                  {t("about.services.plumber.description")}
                </p>
                <div className="aboutpage-service-features">
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.plumber.list.leak_repair")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.plumber.list.drain_cleaning")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.plumber.list.emergency_fix")}
                  </span>
                </div>
              </div>
            </div>

            {/* Gas Chula */}
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <div className="aboutpage-service-card-inner">
                <div className="aboutpage-service-icon-wrapper">
                  <FaFire
                    className="aboutpage-service-icon"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="aboutpage-service-title">
                  {t("about.services.gas_chula.title")}
                </h3>
                <p className="aboutpage-service-description">
                  {t("about.services.gas_chula.description")}
                </p>
                <div className="aboutpage-service-features">
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.gas_chula.list.installation")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.gas_chula.list.repair")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.gas_chula.list.safety_check")}
                  </span>
                </div>
              </div>
            </div>

            {/* AC Service */}
            <div className="aboutpage-service-card aboutpage-card-shadow">
              <div className="aboutpage-service-card-inner">
                <div className="aboutpage-service-icon-wrapper">
                  <FaWind
                    className="aboutpage-service-icon"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="aboutpage-service-title">
                  {t("about.services.ac_service.title")}
                </h3>
                <p className="aboutpage-service-description">
                  {t("about.services.ac_service.description")}
                </p>
                <div className="aboutpage-service-features">
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.ac_service.list.general_servicing")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.ac_service.list.installation")}
                  </span>
                  <span className="aboutpage-service-feature-tag">
                    {t("about.services.ac_service.list.ac_cleaning")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="aboutpage-how-it-works aboutpage-section">
        <div className="aboutpage-how-it-works-content">
          <h2 className="aboutpage-how-it-works-heading">
            {t("about.how_it_works.heading")}
          </h2>
          <p className="aboutpage-how-it-works-subtitle">
            {t("about.how_it_works.subtitle")}
          </p>
          <div className="aboutpage-how-it-works-columns">
            <div className="aboutpage-how-it-works-column">
              <h3 className="aboutpage-how-it-works-column-title">
                {t("about.how_it_works.users.title")}
              </h3>
              <div className="aboutpage-how-it-works-steps">
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-user">
                    1
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.users.step1.title")}</h4>
                    <p>{t("about.how_it_works.users.step1.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-user">
                    2
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.users.step2.title")}</h4>
                    <p>{t("about.how_it_works.users.step2.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-user">
                    3
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.users.step3.title")}</h4>
                    <p>{t("about.how_it_works.users.step3.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-user">
                    4
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.users.step4.title")}</h4>
                    <p>{t("about.how_it_works.users.step4.text")}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="aboutpage-how-it-works-column">
              <h3 className="aboutpage-how-it-works-column-title">
                {t("about.how_it_works.providers.title")}
              </h3>
              <div className="aboutpage-how-it-works-steps">
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-servitor">
                    1
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.providers.step1.title")}</h4>
                    <p>{t("about.how_it_works.providers.step1.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-servitor">
                    2
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.providers.step2.title")}</h4>
                    <p>{t("about.how_it_works.providers.step2.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-servitor">
                    3
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.providers.step3.title")}</h4>
                    <p>{t("about.how_it_works.providers.step3.text")}</p>
                  </div>
                </div>
                <div className="aboutpage-step">
                  <div className="aboutpage-step-number aboutpage-step-servitor">
                    4
                  </div>
                  <div className="aboutpage-step-text">
                    <h4>{t("about.how_it_works.providers.step4.title")}</h4>
                    <p>{t("about.how_it_works.providers.step4.text")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Security Features Section */}
      <section className="aboutpage-security aboutpage-section">
        <div className="aboutpage-security-content">
          <h2 className="aboutpage-security-heading">
            {t("about.security.heading")}
          </h2>
          <p className="aboutpage-security-subtitle">
            {t("about.security.subtitle")}
          </p>
          <div className="aboutpage-security-features">
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.admin.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.admin.text")}
              </p>
            </div>
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.pin.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.pin.text")}
              </p>
            </div>
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.tracking.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.tracking.text")}
              </p>
            </div>
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.rating.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.rating.text")}
              </p>
            </div>
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.account.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.account.text")}
              </p>
            </div>
            <div className="aboutpage-security-feature">
              <div className="aboutpage-security-icon-wrapper">
                <div className="aboutpage-security-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5" />
                    <path d="M8 11h6" />
                    <circle cx="16.5" cy="15.5" r="1" />
                  </svg>
                </div>
              </div>
              <h3 className="aboutpage-security-feature-title">
                {t("about.security.features.payment.title")}
              </h3>
              <p className="aboutpage-security-feature-text">
                {t("about.security.features.payment.text")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      {/* <section className="aboutpage-values aboutpage-section">
        <div className="aboutpage-values-content">
          <h2 className="aboutpage-values-heading">
            {t("about.values.heading")}
          </h2>
          <p className="aboutpage-values-subtitle">
            {t("about.values.subtitle")}
          </p>
          <div className="aboutpage-values-grid">
            <div className="aboutpage-value">
              <div className="aboutpage-value-icon">🔒</div>
              <h3 className="aboutpage-value-title">
                {t("about.values.security.title")}
              </h3>
              <p className="aboutpage-value-text">
                {t("about.values.security.text")}
              </p>
            </div>
            <div className="aboutpage-value">
              <div className="aboutpage-value-icon">⚡</div>
              <h3 className="aboutpage-value-title">
                {t("about.values.efficiency.title")}
              </h3>
              <p className="aboutpage-value-text">
                {t("about.values.efficiency.text")}
              </p>
            </div>
            <div className="aboutpage-value">
              <div className="aboutpage-value-icon">🤝</div>
              <h3 className="aboutpage-value-title">
                {t("about.values.community.title")}
              </h3>
              <p className="aboutpage-value-text">
                {t("about.values.community.text")}
              </p>
            </div>
            <div className="aboutpage-value">
              <div className="aboutpage-value-icon">✨</div>
              <h3 className="aboutpage-value-title">
                {t("about.values.quality.title")}
              </h3>
              <p className="aboutpage-value-text">
                {t("about.values.quality.text")}
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="aboutpage-cta aboutpage-section">
        <div className="aboutpage-cta-content">
          <h2 className="aboutpage-cta-heading">{t("about.cta.heading")}</h2>
          <p className="aboutpage-cta-text">{t("about.cta.text")}</p>
          <div className="aboutpage-cta-buttons">
            <button
              className="aboutpage-cta-button primary"
              onClick={() => navigate("/")}
            >
              {t("about.cta.button_find")}
            </button>
            <button
              className="aboutpage-cta-button secondary"
              onClick={() => navigate("/signup/servitor")}
            >
              {t("about.cta.button_provider")}
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
